// Dev environment
// Deployed to: dev-oculus.lokalbase.app
// API: api-dev-oculus.lokalbase.app

export const environment = {
  production: false,
  envName: 'dev',
  tenantId: 'cebcd017-4191-4dfa-8651-0db7f81156e8',
  tenantAlias: 'oculus-dev',
  qrBaseUrl: 'https://dev-oculus.lokalbase.app',
  api: {
    httpUrl: 'https://api-dev-oculus.lokalbase.app/graphql',
    wsUrl: 'wss://api-dev-oculus.lokalbase.app/graphql',
  },
  features: {
    oauthLogin: false,
  },
  oauth: {
    google: { clientId: '' },
    facebook: { appId: '' },
  },
} as const;
